import { BaseViewModel } from "@iot-platform/core";
import { StationGetSelectedUseCase } from "@station/domain/usecases/station-get-selected.usecase.ts";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class StationCountHeaderViewmodel extends BaseViewModel {
    @observable
    selectedStationsCount = 0;

    constructor(
        @inject(StationGetSelectedUseCase)
        private readonly stationGetSelectedUseCase: StationGetSelectedUseCase,
    ) {
        super();
        makeObservable(this);
    }

    @action
    override didMount(): void {
        this.initViewData();
    }

    initViewData(): void {
        this.addSub(
            this.stationGetSelectedUseCase.execute().subscribe((stations) => {
                runInAction(() => {
                    this.selectedStationsCount = stations.length;
                });
            }),
        );
    }
}
